import { createFileRoute } from '@tanstack/react-router';
import { TalhaoDetailView } from '@/modules/agronomia/components/TalhaoDetailView';

// Tela 05 · Talhão (detalhe) — manejo + histórico de visitas.
export const Route = createFileRoute('/_authed/agronomia_/talhoes_/$id')({
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <TalhaoDetailView talhaoId={Number(id)} />;
}
